"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPageContentGroups = exports.buildPageContentIdByUrl = exports.buildPageParametersByUrl = void 0;
/**
 * Nimmt die Url, den page_type entgegen und gibt die dazugehörigen page_ Parameter zurück.
 * Je nach Seite können noch z.B. zusätzliche page_contentgroups oder eine präzisere page_content_id notwendig sein, welche nicht in der URl abgebildet sind.
 *
 * @category Parameter
 * @param url
 * @param pageType
 *
 */
const buildPageParametersByUrl = (url, pageType) => {
    var _a;
    const pageContentId = (0, exports.buildPageContentIdByUrl)(url);
    const pageContentIdSegments = pageContentId.split('.');
    const domain = `${pageContentIdSegments[0]}.${pageContentIdSegments[1]}`;
    const pageContentGroups = (0, exports.buildPageContentGroups)(pageContentIdSegments);
    const page = pageContentIdSegments.length > 2 ? pageContentIdSegments[pageContentIdSegments.length - 1] : null;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ page_content_id: pageContentId, page_type: pageType, page_contentgroup_1: domain }, (pageContentGroups[2] && { page_contentgroup_2: pageContentGroups[2] })), (pageContentGroups[3] && { page_contentgroup_3: pageContentGroups[3] })), (pageContentGroups[4] && { page_contentgroup_4: pageContentGroups[4] })), (pageContentGroups[5] && { page_contentgroup_5: pageContentGroups[5] })), (pageContentGroups[6] && { page_contentgroup_6: pageContentGroups[6] })), (pageContentGroups[7] && { page_contentgroup_7: pageContentGroups[7] })), (page && { page_contentgroup_9: page })), { page_variant: (_a = window.KameleoonVariantName) !== null && _a !== void 0 ? _a : 'original' });
};
exports.buildPageParametersByUrl = buildPageParametersByUrl;
/**
 * Nimmt die Url entgegen und generiert eine `page_content_id`
 *
 * @category Parameter
 * @param url
 */
const buildPageContentIdByUrl = (url) => {
    const subdomain = url.hostname.includes('.') ? url.hostname.split('.')[0] : 'www';
    const domain = url.hostname.replace(`${subdomain}.`, '');
    const formattedDomain = domain.replaceAll('.', '_');
    const pathname = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
    const navigationLevel = pathname.replaceAll('/', '.');
    let pageContentId = `${subdomain}.${formattedDomain}`;
    if (navigationLevel && navigationLevel.length !== 1) {
        pageContentId += navigationLevel;
    }
    return pageContentId;
};
exports.buildPageContentIdByUrl = buildPageContentIdByUrl;
/**
 * Nimmt contentId Segmente entgegen und erzeugt daraus ein Array mit den page_content_groups.
 * Wobei das letzte Element nicht gesetzt wird, da dieses über die page_content_group_9 abgedeckt wird.
 * @param pageContentIdSegments
 */
const buildPageContentGroups = (pageContentIdSegments) => {
    let pageContentGroups = [];
    pageContentIdSegments.forEach((pageContendIdSegment, index) => {
        if (pageContentIdSegments.length > index + 1) {
            pageContentGroups[index] = pageContendIdSegment;
        }
    });
    return pageContentGroups;
};
exports.buildPageContentGroups = buildPageContentGroups;
